import ReviewCardComponent from './ReviewCardComponent'

export default ReviewCardComponent
